// extracted by mini-css-extract-plugin
export default {"removalConfirmationModal":"RemovalConfirmationModal__removalConfirmationModal___IlZkE","confirmButton":"RemovalConfirmationModal__confirmButton___wY4m8"};